/* Pure Desi R5-9c: quick-add success feedback.
   The theme's product-form dispatches a non-bubbling "add-to-cart" Event on
   itself after a successful ajax add; we catch it in the capture phase.
   Scope: card quick-adds only (inside <quick-add-to-cart>) — the PDP form
   keeps the theme's own feedback. Text swap is a state change, not motion,
   so no reduced-motion variant is needed; the colour ease lives in CSS. */
(function () {
	if (window.__pdQuickAddFeedback) return;
	window.__pdQuickAddFeedback = true;

	var RESET_MS = 1600;
	/* [R9-2] 5 Oct 2026 (Abhi: "do all"): the label no longer snaps. The old words fade and soften away, the new ones come into
	   focus (about 0.3 s); going back is quieter. Opacity and blur only: the label is inline text, which cannot move.
	   Reduced motion: the words change at once, as before. */
	var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
	function swap(el, text, quiet) {
		if (RM || !el.animate) { el.textContent = text; return; }
		var out = el.animate([{ opacity: 1, filter: 'blur(0px)' }, { opacity: 0, filter: 'blur(' + (quiet ? 1 : 2) + 'px)' }],
			{ duration: quiet ? 90 : 110, easing: 'cubic-bezier(.32,0,.67,0)', fill: 'forwards' });
		out.onfinish = function () {
			el.textContent = text; out.cancel();
			el.animate([{ opacity: 0, filter: 'blur(' + (quiet ? 1 : 2) + 'px)' }, { opacity: 1, filter: 'blur(0px)' }],
				{ duration: quiet ? 160 : 200, easing: 'cubic-bezier(.22,1,.36,1)' });
		};
	}

	document.addEventListener('add-to-cart', function (e) {
		var wrap = e.target && e.target.closest ? e.target.closest('quick-add-to-cart') : null;
		if (!wrap) return;
		var btn = wrap.querySelector('[data-js-product-add-to-cart]');
		var txt = btn && btn.querySelector('.button__text');
		if (!btn || !txt || btn.hasAttribute('data-pd-added')) return;
		btn.setAttribute('data-pd-added', '');
		var original = txt.textContent;
		swap(txt, '✓ Added', false);
		btn.classList.add('pd-added');
		setTimeout(function () {
			swap(txt, original, true);
			btn.classList.remove('pd-added');
			btn.removeAttribute('data-pd-added');
		}, RESET_MS);
	}, true);
})();
